module.exports = __webpack_public_path__ + "img/smile.266b2ca6.svg";